import { patchState, signalStore, withComputed, withMethods, withProps, withState } from "@ngrx/signals";
import { ApprovalGroupService } from "./service/approval.group.service";
import { s25Resource } from "../../util/s25.resource";
import { S25Util } from "../../util/s25-util";
import { Item } from "../../pojo/Item";
import { NameService } from "../../services/name.service";

interface ApprovalGroups {
    loadApprovalContacts: boolean;
}

export const ApprovalGroupsStore = signalStore(
    withState<ApprovalGroups>({
        loadApprovalContacts: false,
    }),
    withProps(() => ({
        _groups: s25Resource({
            loader: async () => {
                const [approvalGroups] = await S25Util.Maybe(ApprovalGroupService.getApprovalGroups());
                if (approvalGroups) return approvalGroups;
            },
        }),
    })),
    withComputed((store) => ({
        approvalGroups: () => store._groups.value(),
    })),
    withComputed((store) => ({
        _contactIds: () => {
            const groups = store.approvalGroups();
            return S25Util.array.uniqueByProp(
                groups?.flatMap(
                    (group) =>
                        group.contacts?.map((contact) => ({
                            itemId: contact.contId,
                            itemTypeId: Item.Ids.Contact,
                        })) ?? [],
                ) ?? [],
                "itemId",
            );
        },
        groupNames: () =>
            new Map<number, string>(
                store
                    .approvalGroups()
                    ?.flatMap((group) => (group.approvalGroupId == null ? [] : [[group.approvalGroupId, group.name]])),
            ),
    })),
    withProps((store) => ({
        _contacts: s25Resource({
            if: () => store.loadApprovalContacts() && store._contactIds().length > 0,
            params: () => store.loadApprovalContacts(),
            loader: async () => {
                const [names] = await S25Util.Maybe(NameService.getNames(store._contactIds()));
                if (names) return names;
            },
        }),
    })),
    withComputed((store) => ({
        contacts: () => {
            const contacts = store._contacts.value();
            if (contacts) {
                const nameMap: Record<number, string> = {};
                for (const [contId, contactName] of Object.entries(contacts)) {
                    const nameKey = Number(contId.split("-")[0]);
                    if (!isNaN(nameKey)) nameMap[nameKey] = contactName;
                }
                return nameMap;
            }
        },
    })),
    withMethods((store) => ({
        loadContacts: () => patchState(store, { loadApprovalContacts: true }),
    })),
);
